import * as React from 'react';

import { EStartReviewErrorCode } from '../../../types/newReview/startReviewErrorCodes';
import {
  TripNotFoundError,
  DefaultError,
  OfferOwnerError,
  ReviewOnModerationError,
  ReviewAlreadyExistsError,
  ReviewTimeLimitAfterTripExceededError,
} from '../errors';

interface IMapErrorToDisplayHandlers {
  onClose: () => void;
  onBookClick: () => void;
  onRequestAuth: () => void;
  onReload: () => void;
}

/**
 * Маппинг кодов ошибок на соответствующие компоненты
 */
export function mapErrorToDisplay(
  error: EStartReviewErrorCode,
  handlers: IMapErrorToDisplayHandlers,
): React.ReactElement {
  const { onClose, onRequestAuth, onBookClick, onReload } = handlers;

  switch (error) {
    case EStartReviewErrorCode.TripNotFound:
      return <TripNotFoundError onRequestAuth={onRequestAuth} onBookClick={onBookClick} />;
    case EStartReviewErrorCode.OfferOwner:
      return <OfferOwnerError onClose={onClose} />;
    case EStartReviewErrorCode.ReviewOnModeration:
      return <ReviewOnModerationError onClose={onClose} />;
    case EStartReviewErrorCode.ReviewAlreadyExists:
      return <ReviewAlreadyExistsError onClose={onClose} />;
    case EStartReviewErrorCode.ReviewTimeLimitAfterTripExceeded:
      return <ReviewTimeLimitAfterTripExceededError onClose={onClose} />;
    case EStartReviewErrorCode.Unknown:
    default:
      return <DefaultError onReload={onReload} />;
  }
}
